import classes from "../../../styles/Subscription.module.scss";
import CustomIcon from "../../../components/core/CustomIcon/CustomIcon";
import Button from "../../../components/core/Button/Button";
import callIcon from "../../../assets/icons/call.svg";
import { copyToClipBoard } from "../../../utils/chat-utils";
import { useNavigate } from "react-router";
import { APP_PATH } from "../../../routes/route";

function CustomEnterprisePlan() {
  const navigate = useNavigate();
  return (
    <div className={classes.customEntPlanCont}>
      <div className={classes.heading}>Custom Enterprise Plan</div>
      <div className={classes.msgToCust}>
        We will design a custom solution for you as per your business
        requirements.
      </div>
      <div className={classes.flexAndCost}>
        Get plan flexibility and cost control based on your requirements today.
      </div>
      <Button
        label="Contact Us"
        backgroundColor="#00BAF2"
        color="#FFFFFF"
        width="100%"
        clickHandler={() => navigate(`${APP_PATH}/subscription/form`,
                                            {state:{plan:"Custom",planType:"CUSTOM"}})}
      />
      <div className={classes.or}>
        <span>Or</span>
      </div>
      <div className={classes.numberSec}>
        <a href="tel:080-42547226">
          <CustomIcon
            src={callIcon}
            iconHeight={44}
            iconWidth={44}
            className={classes.hoverActive}
          />
        </a>
        <div className={classes.heading}>Give us a call</div>
        <div
          className={classes.number}
          onClick={() => copyToClipBoard("080-42547226")}
        >
          080-42547226
        </div>
      </div>
    </div>
  );
}
export default CustomEnterprisePlan;
